import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        button: {
            cursor: 'pointer',
            display: 'flex',
            padding: theme.spacing(0.75),
            paddingRight: theme.spacing(2),
            whiteSpace: 'nowrap',
            color: theme.palette.secondary[600],
            '@media print': {
                display: 'none',
            },
        },
    }
})

export default useStyles
